<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
            <form action="search-results.html" method="get" style="align-items: flex-start;">
              <label style="width: 75px;height: 150%;font-size: large;">Drug Interaction</label>

            <div>
              <textarea rows = "5" cols = "60" disabled name = "didescription" [(ngModel)]="didescription" class="appointment-form-field" maxlength="250ch" style="width: 100%;height: 150%;"></textarea><br>
            </div>
                  <img src="data:image/jpg;base64,{{myimage}}"  alt="User Image" width="500px" height="400px" style="border: 1px;border-style: inset;"/>
            </form>
            </div>
        </div>
    </div>
  </section>


  </mat-dialog-content>




